import { Capacitor } from "@capacitor/core";

const isDebugErrorOverlayEnabled = () => {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return localStorage.getItem("DEBUG_ERROR_OVERLAY") === "1";
  } catch {
    return false;
  }
};

const isReportableWindowError = (event) => {
  const message = (event.message || "").trim();
  if (event.error instanceof Error && event.error.message.trim()) {
    return true;
  }
  if (message && message !== "Script error.") {
    return true;
  }
  return !!(event.filename && event.lineno);
};

export const formatUnknownError = (reason) => {
  if (reason == null) {
    return "(sin detalle)";
  }
  if (reason instanceof Error) {
    return `${reason.name}: ${reason.message}\n${reason.stack || ""}`;
  }
  if (typeof reason === "object") {
    try {
      return JSON.stringify(reason, null, 2);
    } catch {
      return String(reason);
    }
  }
  return String(reason);
};

export const installGlobalErrorHandlers = (showError) => {
  if (typeof window === "undefined" || typeof showError !== "function") {
    return;
  }

  const showOverlay = isDebugErrorOverlayEnabled();

  window.addEventListener(
    "error",
    (event) => {
      const lines = [
        "[window.error]",
        event.message || "(sin mensaje)",
        event.filename
          ? `${event.filename}:${event.lineno}:${event.colno}`
          : "",
        event.error ? formatUnknownError(event.error) : "",
      ];
      const detail = lines.filter(Boolean).join("\n");
      console.error(detail);
      if (!showOverlay || !isReportableWindowError(event)) {
        return;
      }
      showError(detail);
    },
    true
  );

  window.addEventListener("unhandledrejection", (event) => {
    const detail = `[unhandledrejection]\n${formatUnknownError(event.reason)}`;
    console.error(detail);
    if (!showOverlay) {
      return;
    }
    const reasonText = formatUnknownError(event.reason).trim();
    if (!reasonText || reasonText === "(sin detalle)") {
      return;
    }
    showError(detail);
  });
};
